import { FunctionalComponent, h } from "@stencil/core"

import { DuetColor, DuetMargin, DuetTextFontWeight, DuetTheme } from "../common-types"

export type DuetInternalLabelProps = {
  theme?: DuetTheme
  for?: string
  margin?: DuetMargin | "small"
  size?: "small" | "medium"
  weight?: DuetTextFontWeight
  color?: DuetColor
  id?: string
  class?: string | object
}

export const DuetInternalLabel: FunctionalComponent<DuetInternalLabelProps> = (props, children) => {
  const { theme = "", margin = "auto", size = "medium", weight = "semi-bold", color = "", id = "" } = props

  return (
    <label
      id={id}
      class={{
        "duet-internal-label": true,
        "duet-internal-label-small": size === "small",
        "duet-theme-turva": theme === "turva",
        "duet-small-margin": margin === "small",
        "duet-m-0": margin === "none",
        [`duet-weight-${weight}`]: true,
        [`${props.class}`]: true,
      }}
      htmlFor={props.for}
      style={{ color }}
    >
      <span>{children}</span>
    </label>
  )
}
